import { CanDeactivateFn } from '@angular/router';

/**
 * Deactivate guard for account-setup page.
 * Allows navigation away; can be extended to prompt if form has unsaved changes.
 */
export const accountSetupDeactivateGuard: CanDeactivateFn<unknown> = () => {
  return true;
};
